import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve essere usato all\'interno di AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [utente, setUtente] = useState(null);
  const [caricamento, setCaricamento] = useState(true);
  const [autenticato, setAutenticato] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'https://api.neoflux.it';

  // Configura axios per includere credenziali
  axios.defaults.withCredentials = true;

  useEffect(() => {
    verificaSessione();
  }, []);

  const verificaSessione = async () => {
    try {
      const response = await axios.get('/auth/sessione', {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      if (response.data.autenticato) {
        setAutenticato(true);
        // Carica anche il profilo completo con nome, cognome, tipo_cliente ecc.
        try {
          const profiloRes = await axios.get('/api/profilo', { withCredentials: true });
          const merged = { ...response.data.utente, ...profiloRes.data };
          setUtente(merged);
        } catch (err) {
          console.warn('[AuthContext] profilo non caricato, uso sessione base:', err?.response?.status || err.message);
          setUtente(response.data.utente);
        }
      } else {
        // Non autenticato - imposta solo lo stato, non fare redirect qui
        setAutenticato(false);
        setUtente(null);
      }
    } catch (error) {
      console.error('Errore verifica sessione:', error);
      // In caso di errore, imposta come non autenticato
      setAutenticato(false);
      setUtente(null);
    } finally {
      setCaricamento(false);
    }
  };

  const logout = () => {
    // Redirect diretto al backend logout, che poi gestirà la catena di redirect
    window.location.href = '/auth/logout';
  };

  const ricaricaUtente = async () => {
    try {
      const response = await axios.get(`${API_URL}/profilo`);
      if (response.data.successo) {
        setUtente({
          ...utente,
          ...response.data.profilo
        });
      }
    } catch (error) {
      console.error('Errore ricarica utente:', error);
    }
  };

  const value = {
    utente,
    autenticato,
    caricamento,
    logout,
    ricaricaUtente,
    API_URL
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

